module.exports = __webpack_public_path__ + "static/media/oneimg.a696a0c8.png";